import React, { useState } from "react";
import styled from "styled-components";
import { COLORS } from "@/react/theme/constants";
import { ArrowUpIcon, PopOutIcon } from "@8x8/oxygen-icon";
import ArrowDownIcon from "@8x8/oxygen-icon/icons/ArrowDownIcon";
import Tooltip from "@8x8/oxygen-tooltip";
import ArrowRightIcon from "@8x8/oxygen-icon/icons/ArrowRightIcon";
import { IconButton } from "@8x8/oxygen-icon-button";
import Input from "@/react/components/Input";
import {
  DropdownController,
  SpaceBetweenContainer,
} from "@/react/features/support-tools/dialplans/styled";
import Button from "@8x8/oxygen-button";
import CloseIcon from "@8x8/oxygen-icon/icons/CloseIcon";

const RuleSetContainer = styled.div`
  border: 1px solid ${COLORS.secondary};
  border-radius: 8px;
`;

const NormalizationRule = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 6fr 0.5fr 2fr 0.5fr;
  align-items: center;
  gap: 12px;
  padding: 8px;
`;

const Regex = styled.div`
  font-family: monospace;
  font-size: 14px;
  overflow: auto;
`;

const RuleSetDetailsContainer = styled.div`
  padding: 8px;
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DropdownIcons = styled.div`
  display: flex;
  align-items: center;
`;

const regExrUrl = (regex) =>
  `https://regexr.com/?expression=${encodeURIComponent(regex)}`;

export const RuleSet = ({
  ruleSetType,
  normalizationRule,
  description,
  isEditable = false,
  onChangeRegExpr,
  onChangeReplace,
  onChangeDescription,
  onAddNormalizationRule,
  isDeletable,
  onDeleteRuleSet,
  onDeleteNormalizationRule,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleOpenRegExr = (regex) => {
    window.open(regExrUrl(regex), "_blank", "noopener,noreferrer");
  };

  return (
    <RuleSetContainer>
      <DropdownController onClick={() => setIsExpanded(!isExpanded)}>
        <div>{ruleSetType}</div>
        <DropdownIcons>
          {isExpanded ? <ArrowUpIcon /> : <ArrowDownIcon />}
          {isEditable && isDeletable && (
            <IconButton onClick={onDeleteRuleSet}>
              <CloseIcon size={28} />
            </IconButton>
          )}
        </DropdownIcons>
      </DropdownController>
      {isExpanded && (
        <>
          <RuleSetDetailsContainer>
            {isEditable ? (
              <Input
                value={description}
                placeholder={"Type optional description..."}
                onChange={(e) => onChangeDescription(e.target.value)}
              />
            ) : (
              <div>{description}</div>
            )}

            {isEditable && (
              <SpaceBetweenContainer>
                <div>Normalization Rule</div>
                <Button variant={"tertiary"} onClick={onAddNormalizationRule}>
                  Add
                </Button>
              </SpaceBetweenContainer>
            )}
          </RuleSetDetailsContainer>

          {normalizationRule.map((rule, index) => (
            <NormalizationRule>
              <Tooltip title={"Test using regexr.com"}>
                <IconButton onClick={() => handleOpenRegExr(rule.regExpr)}>
                  <PopOutIcon size={16} />
                </IconButton>
              </Tooltip>
              {isEditable ? (
                <Input
                  value={rule.regExpr}
                  placeholder={"Type regular expression..."}
                  onChange={(e) => onChangeRegExpr(e.target.value, index)}
                />
              ) : (
                <Regex>{rule.regExpr}</Regex>
              )}
              <ArrowRightIcon size={16} />

              {isEditable ? (
                <Tooltip title={"Type the replace rule"}>
                  <Input
                    value={rule.replace}
                    onChange={(e) => onChangeReplace(e.target.value, index)}
                  />
                </Tooltip>
              ) : (
                <Regex>{rule.replace}</Regex>
              )}

              {isEditable && normalizationRule.length > 1 && (
                <IconButton onClick={() => onDeleteNormalizationRule(index)}>
                  <CloseIcon />
                </IconButton>
              )}
            </NormalizationRule>
          ))}
        </>
      )}
    </RuleSetContainer>
  );
};
